var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsejos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4689_15245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6944 26.2012C15.5067 26.0587 13.582 25.9102 11.6512 25.8239C11.1154 25.7998 10.5654 25.9243 10.0356 26.0427C8.7511 26.3277 7.47664 26.6548 6.19816 26.9559C5.36725 27.1526 4.85546 26.6468 5.03609 25.8099C5.40338 24.122 5.84091 22.4461 6.11387 20.7421C6.24432 19.9253 6.07975 19.0562 6.01753 18.2113C5.74658 14.5264 5.90112 10.8555 6.38481 7.20073C6.65777 5.12346 8.04864 3.7627 10.1741 3.49576C13.5017 3.07629 16.8434 2.85552 20.1972 3.10439C21.8389 3.22682 23.4927 3.31312 25.1124 3.58206C27.0291 3.90118 28.2995 5.33219 28.5444 7.29305C29.1465 12.14 29.1686 16.991 28.5303 21.838C28.2473 23.9915 26.8023 25.4245 24.6186 25.6493C22.2343 25.8942 19.8379 26.0326 17.6944 26.1992V26.2012ZM18.6999 12.0517C18.6999 11.0181 18.6999 9.98648 18.6999 8.95286C18.6999 8.42702 18.5193 8.00354 18.0075 7.79682C17.2388 7.48372 16.5604 8.04167 16.5544 9.01107C16.5424 11.0261 16.5444 13.0432 16.5524 15.0582C16.5544 15.8209 16.9879 16.3247 17.6061 16.3227C18.2684 16.3227 18.6959 15.8309 18.6999 15.0502C18.7039 14.0507 18.6999 13.0512 18.6999 12.0517ZM16.5604 20.5615C16.5604 20.6779 16.5504 20.7943 16.5604 20.9107C16.6267 21.5429 17.0241 21.9283 17.6201 21.9423C18.1681 21.9564 18.6076 21.573 18.6758 20.9629C18.712 20.6378 18.6959 20.2946 18.6377 19.9734C18.5113 19.289 17.7466 18.9579 17.1264 19.281C16.5905 19.56 16.5584 20.0537 16.5584 20.5635L16.5604 20.5615Z",
    fill: "#BBBFC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4689_15245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.002,
    height: 24,
    fill: "white",
    transform: "translate(5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsejos);
export default __webpack_public_path__ + "static/media/consejos.97599234103e433529ea3673a3f45b71.svg";
export { ForwardRef as ReactComponent };